import React from "react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaMoon,
  FaPause,
  FaPlay,
  FaSun,
} from "react-icons/fa";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { toAbsolutePhotoUrl } from "../../../../../../../services/settingsPhotoServices";

export default function HomePreviewPanel({
  settings,
  headerImages,
  selectedGallery,
  carrouselPhotos,
  previewDark,
  setPreviewDark,
  slide,
  setSlide,
  autoPlay,
  setAutoPlay,
}) {
  const currentHeader = headerImages[slide] || headerImages[0];

  return (
    <aside className="space-y-5">
      <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

        <div className="p-4 sm:p-5">
          <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                Prévisualisation
              </p>

              <h3 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                Rendu de la page
              </h3>
            </div>

            <div className="flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => setAutoPlay((value) => !value)}
                className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                {autoPlay ? <FaPause /> : <FaPlay />}
                {autoPlay ? "Pause" : "Lecture"}
              </button>

              <button
                type="button"
                onClick={() => setPreviewDark((value) => !value)}
                className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                {previewDark ? <FaSun /> : <FaMoon />}
                {previewDark ? "Clair" : "Sombre"}
              </button>
            </div>
          </div>

          <div className={previewDark ? "dark" : ""}>
            <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
              <div className="relative h-[260px] bg-slate-200 dark:bg-slate-800">
                {headerImages.map((image, index) => (
                  <div
                    key={image.id}
                    className={`absolute inset-0 transition-opacity duration-700 ${
                      index === slide ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    <img
                      src={image.src}
                      alt={image.label}
                      className="h-full w-full object-cover"
                      onError={(event) => {
                        event.currentTarget.src = image.fallback;
                      }}
                    />

                    <div
                      className={`absolute inset-0 ${
                        image.align === "right"
                          ? "bg-gradient-to-l from-slate-900/70 via-slate-900/35 to-transparent"
                          : "bg-gradient-to-r from-slate-900/70 via-slate-900/35 to-transparent"
                      }`}
                    />
                  </div>
                ))}

                <div
                  className={`absolute inset-0 flex items-center ${
                    currentHeader.align === "right"
                      ? "justify-end text-right"
                      : "justify-start text-left"
                  }`}
                >
                  <div className="max-w-[80%] px-5 text-white drop-shadow-xl sm:max-w-[65%] sm:px-8">
                    <div
                      className="animate-fadein prose prose-invert max-w-none"
                      dangerouslySetInnerHTML={{
                        __html:
                          currentHeader.text ||
                          "<h1>Votre titre</h1><p>Votre texte apparaîtra ici.</p>",
                      }}
                    />
                  </div>
                </div>

                <button
                  type="button"
                  className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-slate-900/40 p-2 text-white transition hover:bg-slate-900/60"
                  onClick={() =>
                    setSlide(
                      (current) =>
                        (current - 1 + headerImages.length) %
                        headerImages.length
                    )
                  }
                  title="Précédent"
                >
                  <FaChevronLeft />
                </button>

                <button
                  type="button"
                  className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-slate-900/40 p-2 text-white transition hover:bg-slate-900/60"
                  onClick={() =>
                    setSlide((current) => (current + 1) % headerImages.length)
                  }
                  title="Suivant"
                >
                  <FaChevronRight />
                </button>

                <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-2">
                  {headerImages.map((image, index) => (
                    <button
                      key={image.id}
                      type="button"
                      onClick={() => setSlide(index)}
                      className={`h-2.5 w-2.5 rounded-full border border-white/70 ${
                        index === slide ? "bg-white" : "bg-transparent"
                      }`}
                      aria-label={`Aller au visuel ${index + 1}`}
                    />
                  ))}
                </div>
              </div>

              <section className="bg-gray-100 p-5 dark:bg-slate-800 dark:text-white">
                <div className="grid gap-5 lg:grid-cols-[140px,1fr] lg:items-center">
                  <div className="flex h-32 items-center justify-center rounded-2xl bg-white p-3 dark:bg-slate-900">
                    <img
                      src={
                        toAbsolutePhotoUrl(settings.logo_club?.trim() || "") ||
                        "/img/no-image.jpg"
                      }
                      alt="Logo club"
                      className="max-h-full max-w-full object-contain"
                      onError={(event) => {
                        event.currentTarget.src = "/img/no-image.jpg";
                      }}
                    />
                  </div>

                  <div>
                    <h2 className="text-2xl font-extrabold">
                      {settings.about_title || "À propos de notre club"}
                    </h2>

                    <div
                      className="prose prose-slate mt-3 max-w-none text-sm leading-relaxed dark:prose-invert"
                      dangerouslySetInnerHTML={{
                        __html:
                          settings.about_content ||
                          "<p>Ajoutez votre présentation ici.</p>",
                      }}
                    />
                  </div>
                </div>
              </section>

              <section className="p-5">
                <h4 className="mb-3 text-sm font-bold text-slate-700 dark:text-slate-200">
                  Carrousel photo
                </h4>

                {settings.carrousel_id ? (
                  <>
                    <p className="mb-3 text-sm text-slate-600 dark:text-slate-300">
                      Album sélectionné :{" "}
                      <span className="font-bold">
                        {selectedGallery?.titre || `#${settings.carrousel_id}`}
                      </span>
                    </p>

                    {carrouselPhotos.length > 0 ? (
                      <div className="home-settings-carousel overflow-hidden rounded-2xl ring-1 ring-slate-200 dark:ring-slate-800">
                        <Carousel
                          autoPlay={carrouselPhotos.length > 1}
                          infiniteLoop={carrouselPhotos.length > 1}
                          useKeyboardArrows
                          showThumbs={false}
                          showStatus={false}
                          showIndicators={carrouselPhotos.length > 1}
                          showArrows={carrouselPhotos.length > 1}
                          interval={4500}
                          stopOnHover
                          swipeable
                          emulateTouch
                          dynamicHeight={false}
                        >
                          {carrouselPhotos.map((photo) => (
                            <div key={photo.id} className="hs-slide">
                              <img
                                src={toAbsolutePhotoUrl(photo.photo_url)}
                                alt={photo.description || "Photo"}
                                onError={(event) => {
                                  event.currentTarget.src = "/img/no-image.jpg";
                                }}
                              />
                            </div>
                          ))}
                        </Carousel>
                      </div>
                    ) : (
                      <p className="text-sm text-slate-500 dark:text-slate-400">
                        Cet album n’a pas encore de photos actives.
                      </p>
                    )}
                  </>
                ) : (
                  <p className="text-sm text-slate-500 dark:text-slate-400">
                    Aucun album sélectionné.
                  </p>
                )}
              </section>
            </div>
          </div>
        </div>

        <style>{`
          .animate-fadein {
            animation: fadein .5s ease-out both;
          }

          @keyframes fadein {
            from {
              opacity: 0;
              transform: translateY(6px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .home-settings-carousel .carousel .slide {
            background: transparent !important;
          }

          .home-settings-carousel .carousel .slide img {
            height: 180px;
            width: 100%;
            object-fit: cover;
            display: block;
          }

          .home-settings-carousel .carousel .control-dots {
            margin: 0 0 6px 0;
          }
        `}</style>
      </section>
    </aside>
  );
}